import { useContext } from 'react';
import { RealtimeContext } from '../../contexts/realtime-context';
import type { RealtimeContextValue } from '../../types/realtime-context.type';

/**
 * Returns the shared realtime socket context.
 *
 * @returns Realtime socket state and subscription helpers.
 * @throws When used outside `RealtimeProvider`.
 */
export const useRealtime = (): RealtimeContextValue => {
  const context = useContext(RealtimeContext);
  if (!context) {
    throw new Error('useRealtime must be used within a RealtimeProvider');
  }

  return context;
};
